export default __webpack_public_path__ + "static/media/p3_m.e71c6f98.png";